export default __webpack_public_path__ + "static/media/5856-image-picture.53d9d545.gif";